module.exports = __webpack_public_path__ + "img/dog-food-5168940_640.c44c8f0b.jpg";